import { render, staticRenderFns } from "./actions-sinistre.vue?vue&type=template&id=7d650608&"
import script from "./actions-sinistre.vue?vue&type=script&lang=js&"
export * from "./actions-sinistre.vue?vue&type=script&lang=js&"
import style0 from "./actions-sinistre.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports